// ShellLoading — initial app boot skeleton (no spinner; per Anti-Patterns).

export function ShellLoading(): JSX.Element {
  return (
    <main
      className="grid min-h-screen place-items-center bg-surface-0"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="space-y-3">
        <div className="h-6 w-32 rounded bg-surface-2 motion-safe:animate-pulse motion-reduce:animate-none motion-reduce:opacity-60" />
        <div className="h-3 w-24 rounded bg-surface-2 motion-safe:animate-pulse motion-reduce:animate-none motion-reduce:opacity-60" />
      </div>
    </main>
  );
}
